<div class="info-modal-container">
  <div class="info-modal-container__info">{{ infoHeader | translate }}</div>
  <div *ngIf="infoIcon" class="info-modal-container__icon"><img [src]="infoIcon" /></div>
  <div class="info-modal-container__content">
    {{ infoTxt | translate }}
  </div>
  <div class="info-modal-container__btn-container">
    <ui-custom-button [btnTxt]="'info_modal.Okay' | translate" (clickEvent)="dismissModal()"></ui-custom-button>
  </div>
</div>
